export default "__VITE_ASSET__cc54277c__"